import React from 'react';

class Settings extends React.Component {
  render() {
    return (
      <div>
        <h1 data-testid="settings-title">Estou aqui Pagina settings</h1>
      </div>
    );
  }
}

export default Settings;
